import * as actionTypes from './actions/actionTypes';
import { updateObject } from '../../global/utility';

const initialState = {
    loading_auth_status: true,
    connected: false,
    connect_url: null,
    loading_songs: false,
    songs: [],
    songs_total: 0,
    songs_next_offset: null,
    loading_song_detail: false,
    selected_song: null,
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.FETCH_PCO_AUTH_STATUS_START:
            return updateObject(state, { loading_auth_status: true });
        case actionTypes.FETCH_PCO_AUTH_STATUS_SUCCESS:
            return updateObject(state, {
                loading_auth_status: false,
                connected: action.data.connected,
                connect_url: action.data.connect_url
            });
        case actionTypes.FETCH_PCO_AUTH_STATUS_FAILURE:
            return updateObject(state, { loading_auth_status: false, connected: false });

        case actionTypes.FETCH_PCO_SONGS_START:
            return updateObject(state, { loading_songs: true });
        case actionTypes.FETCH_PCO_SONGS_SUCCESS:
            const songs = action.append ? state.songs.concat(action.data.songs) : action.data.songs;
            return updateObject(state, {
                loading_songs: false,
                songs: songs,
                songs_total: action.data.total,
                songs_next_offset: action.data.next_offset
            });
        case actionTypes.FETCH_PCO_SONGS_FAILURE:
            return updateObject(state, { loading_songs: false });

        case actionTypes.FETCH_PCO_SONG_DETAIL_START:
            return updateObject(state, { loading_song_detail: true });
        case actionTypes.FETCH_PCO_SONG_DETAIL_SUCCESS:
            return updateObject(state, { loading_song_detail: false, selected_song: action.data.song });
        case actionTypes.FETCH_PCO_SONG_DETAIL_FAILURE:
            return updateObject(state, { loading_song_detail: false });

        default:
            return state;
    }
};

export default reducer;
